import { render, staticRenderFns } from "./PlacementsList.vue?vue&type=template&id=88e01aa4&scoped=true&lang=pug&"
import script from "./PlacementsList.vue?vue&type=script&lang=js&"
export * from "./PlacementsList.vue?vue&type=script&lang=js&"
import style0 from "./PlacementsList.vue?vue&type=style&index=0&id=88e01aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e01aa4",
  null
  
)

export default component.exports